import React from 'react';
import { Global, css } from '@emotion/react';


export const GlobalStyles = () => {
  return (
    <Global styles={css`body { font-family: "Ubuntu"; }`} />
  );
}
